import React from 'react'

import { SignatureWizardSteps } from '@/redux/ducks/signature/edit'
import SignatureFormActions from './signature-form/signature-form-actions'
import SignaturePlacementActions from './signature-placement/signature-placement-actions'
import { useAppSelector } from '@/redux/store'

interface SignatureWizardActionsProps {
  onAbort?: () => void,
}

const SignatureWizardActions = ({ onAbort }: SignatureWizardActionsProps) => {
  const activeStep = useAppSelector(state => state.signature.edit.activeStep)

  switch (activeStep) {
    case SignatureWizardSteps.form:
      return <SignatureFormActions onAbort={onAbort} />
    case SignatureWizardSteps.signaturePlacement:
      return <SignaturePlacementActions />
  }
}

export default React.memo(SignatureWizardActions)
